<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Виды деятельности</h5>
      <template v-if="typesOfActivities?.length">
        <ul class="info-list mt-2">
          <li
            class="border-bottom py-2"
            v-for="typeOfActivity in typesOfActivities.slice(0, 5)"
            :key="typeOfActivity.code"
          >
            <span class="info-value"
              >{{ typeOfActivity?.code }} {{ typeOfActivity?.name }}</span
            >
            <!-- <a :href="`/counter-parties/${contract.customer.inn}`">{{
              contract.customer.name
            }}</a>
            <span class="info-value"
              >{{ contract.purchase_objects?.length || 0 }} контрактов на сумму
              {{ formatPrice(contract.price) || 0 }}
            </span> -->
          </li>
        </ul>
      </template>
      <template v-else><p>Нет данных</p> </template>
      <button
        class="btn-primary btn-small d-block ms-auto mt-2"
        @click="emitChangeTab('tab-typesOfActivities')"
      >
        Подробнее
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TypesOfActivitiesInfo",
  props: {
    typesOfActivities: Array,
  },
  setup(_, { emit }) {
    const emitChangeTab = (newTab) => {
      emit("change-tab", newTab);
    };
    return {
      emitChangeTab,
    };
  },
};
</script>
